<template>
    <div class="info">
<!--        <img style="object-fit: fill; width: 100%" src="../assets/images/v2_s3u2md.png" alt="">-->
        <div class="title">CONTACT US</div>
        <div class="title">联系我们</div>

        <div class="info-text">
            <div class="contact-container">
                <div class="contact-row">
                    <div class="contact-column">
                        <p>电话: <span>19311591487</span></p>
                    </div>

                    <div class="contact-column">
                        <p>邮箱: <span>iliuer@163.com</span></p>
                    </div>
                </div>
                <div class="contact-row">
                    <div class="contact-column">
                        <p>邮编: <span>410012</span></p>
                    </div>
                    <div class="contact-column">
                        <p>网址: <span>www.kingvil.com</span></p>
                    </div>
                </div>
                <div class="contact-row">
                    <div class="contact-column" style="width: 100%">
                        <p>地址: <span>湖南省长沙市岳麓山大学科技城岳麓街道科技创意园5栋417房</span></p>
                    </div>
                </div>
            </div>
            <div class="right">
                <img src="../assets/images/qr_code.jpg" alt="" width="100">
                <span>扫码关注</span>
                <div class="btns">
                    <el-button text>首页</el-button>
                    <el-button text>解决方案</el-button>
                    <el-button text>应用案例</el-button>
                    <el-button text>技术服务</el-button>
                    <el-button text>新闻资讯</el-button>
                    <el-button text>党建动态</el-button>
                    <el-button text>关于我们</el-button>
                </div>
            </div>
            <div class="link">
                <div>
                    <el-link href="https://mee.gov.cn" :underline="false" target="_blank" type="warning">生态环境部</el-link>
                    <el-link href="https://www.envsc.cn" :underline="false" target="_blank" type="warning">环境保护部污染源监控中心</el-link>
                    <el-link href="http://www.chinaeol.net" :underline="false" target="_blank" type="warning">中国环境在线</el-link>
                    <el-link href="https://www.gov.cn" :underline="false" target="_blank" type="warning">中央人民政府</el-link>
                </div>
                <el-dropdown
                        trigger="click"
                        placement="top"
                        @command="handleCommand"
                        max-height="300px"
                        >
                    <el-button type="primary">
                        友情链接<el-icon class="el-icon--right"><arrow-down /></el-icon>
                    </el-button>
                    <template #dropdown>
                        <el-dropdown-menu
                                style="background-color: black; border-color: black"
                                >
                            <el-dropdown-item command="http://sthjj.cq.gov.cn/">重庆市生态环境局</el-dropdown-item>

                            <el-dropdown-item command="http://sthjj.beijing.gov.cn/">北京市生态环境局</el-dropdown-item>

                            <el-dropdown-item command="http://sthj.tj.gov.cn/">天津市生态环境局</el-dropdown-item>

                            <el-dropdown-item command="http://hbepb.hebei.gov.cn/">河北省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="https://sthj.sh.gov.cn/">上海市生态环境局</el-dropdown-item>

                            <el-dropdown-item command="https://sthjt.shanxi.gov.cn/">山西省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthj.ln.gov.cn/">辽宁省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://hbj.jlcity.gov.cn/">吉林省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.ah.gov.cn/">安徽省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.fujian.gov.cn/">福建省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.jiangxi.gov.cn/">江西省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://www.sdein.gov.cn">山东省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.henan.gov.cn/">河南省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.hubei.gov.cn/">湖北省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="https://www.epd.gov.hk/epd/tc_chi/top.html">香港特区环境署</el-dropdown-item>

                            <el-dropdown-item command="http://hbt.jiangsu.gov.cn/">江苏省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.zj.gov.cn/">浙江省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.hunan.gov.cn/">湖南省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.sc.gov.cn/">四川省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthj.guizhou.gov.cn/">贵州省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.yn.gov.cn/">云南省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.shaanxi.gov.cn/">陕西省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://xaepb.xa.gov.cn/xxgk/zzjg/zsjg/5db19c35fd850807833011b9.html">西安市生态环境保护综合执法支队</el-dropdown-item>

                            <el-dropdown-item command="http://sthj.gansu.gov.cn/">甘肃省生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.nx.gov.cn/page/views/index/index.html">宁夏生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.xinjiang.gov.cn/">新疆生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://sthjt.nmg.gov.cn/">内蒙古生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="http://www.hljdep.gov.cn/">黑龙江生态环境厅</el-dropdown-item>

                            <el-dropdown-item command="https://tepu.org.tw/">台湾环境保护联盟</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
        <div class="bottom">
            <div class="bottom-left">
                <img src="../assets/images/guohui.png" alt="">
                <span>湘ICP备2023028755号</span>
            </div>
            <div class="bottom-center">
                <div>

                    ©2023 - 长沙中南经纬环境研究院有限公司 版权所有
                </div>
                <div>
                    湘ICP备2023028755号
                </div>
            </div>
            <div class="blank-link">

            </div>
        </div>


    </div>
</template>

<script>
export default {
  name: "Info",
  methods: {
    handleCommand(c) {
      window.open(c);
    }
  }
}
</script>

<style scoped>
.info {
    background-color: #292D38;

    color: white;
    padding: 40px 0px;
    .bottom {
        margin-left: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .bottom-left {
            width: 30%;
            display: flex;
            align-items: center;
        }
        .bottom-center {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .blank-link {
            width: 30%;
            height: 20px;
        }
    }
}
.title {
    margin-left: 120px;
    text-align: left;
    margin-bottom: 10px;
    font-size: 50px;
}
.info-text {
    margin-left: 120px;
    width: calc(100% - 120px);
    padding: 40px 0;
    font-size: 20px;
    /*text-align: left;*/
    line-height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .contact-container {
        width: 30%;
    }
    .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .btns {
            display: flex;
            justify-content: space-between;
        }
    }
    .link {
        width: 30%;
        font-size: 20px !important;
        .el-link {
            font-size: 18px !important;

            display: block;
            line-height: 35px;
            color: white;
            :hover {
                background-image: linear-gradient(to bottom, rgba(1, 1, 1, 0.05), white);
            }

        }
        .el-button {
            margin-top: 10px;
            background-color: black;
            font-family: "MyCustomFont" !important;
            width: 200px;
            border-color: white;
            box-shadow: 0 0 15px white;
            padding:10px
        }
        .el-icon-arrow-up:before {
            content: "\e6df";
        }
    }
}
.contact-container {
    width: 50%;
    display: flex;
    flex-direction: column;
    font-family: 'Segoe UI', sans-serif;
}

.contact-row  {
    display: flex;
    /*justify-content: space-between;*/
    margin-bottom: 10px;
    width: 100%;
    font-size: 20px;
    :first-child {
        width: 40%;
    }
    :nth-child(2) {
        width: 80%;
    }
}

.contact-column {
    position: relative;
    text-align: left;
    font-family: "MyCustomFont" !important;
}

.contact-column p {
    margin: 0;
    width: 100% !important;
}

.contact-column span {

}
/deep/ .el-dropdown-menu__item:not(.is-disabled) {
    color: white;
}
/deep/ .el-dropdown-menu__item:not(.is-disabled):focus {
    color: black;
}
/deep/ .el-dropdown-menu {
    color: aqua;
    background-color: black !important;
}
</style>